import { Button, Radio, Tag, List } from 'antd'
import { memo, FC, useState, useEffect } from 'react'
import styles from './index.module.scss'

import { useGetSweepNetworks } from '@/hooks/sweep'
import { useTranslation } from '@/services/i18n'
import { SweepNetwork } from '@/services/apis/sweep/models'
import DrawerFooter from '@/components/DrawerFooter'
import NetworkLogo from '@/components/NetworkLogo'

interface IProps {
  defaultValue?: SweepNetwork
  onOk: (network: SweepNetwork) => void
  okText?: string | null
  onCancel: () => void
}

const SelectNetwork: FC<IProps> = props => {
  const { isLoading, data: networks } = useGetSweepNetworks()
  const [selectedNetwork, setSelectedNetwork] = useState<SweepNetwork>()
  const { defaultValue, onOk, onCancel, okText } = props
  const { t } = useTranslation()

  useEffect(() => {
    if (defaultValue) {
      setSelectedNetwork(defaultValue)
    }
  }, [defaultValue])

  const handleChange = (key: string) => {
    const network = networks.find(network => network.networkKey === key)
    setSelectedNetwork(network!)
  }

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <div className={styles.subTitle}>{t('autoSweep.selectNet')}</div>
        <List
          loading={isLoading}
          dataSource={networks}
          rowKey={item => item.networkKey}
          renderItem={item => {
            return (
              <List.Item key={item.networkKey}>
                <Button
                  className={styles.cardBtn}
                  disabled={item.existsAutoSweepPolicy}
                  onClick={() => handleChange(item.networkKey)}
                >
                  <div className={styles.cardText}>
                    <div className={styles.network}>
                      <NetworkLogo src={item?.networkLogo} />
                      <div>
                        {`${item.networkName}`}
                        <Tag>{`${item.blockchainTypeName}`}</Tag>
                      </div>
                    </div>
                    <Radio
                      disabled={item.existsAutoSweepPolicy}
                      checked={item.networkKey === selectedNetwork?.networkKey}
                    />
                  </div>
                </Button>
                {item.existsAutoSweepPolicy && (
                  <div className={styles.isExist}>{t('autoSweep.isSelectNet')}</div>
                )}
              </List.Item>
            )
          }}
        />
      </div>
      <DrawerFooter
        okText={okText || t('common.confirm')}
        onOk={() => onOk(selectedNetwork!)}
        onCancel={() => onCancel()}
        disabledOk={!selectedNetwork}
      />
    </div>
  )
}

export default memo(SelectNetwork)
